export default "__VITE_ASSET__b1b207a5__"